exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rim-hotspot[data-v-d9436604]{width:3.5%;height:3.5%;border-radius:25px;color:#fff;box-shadow:7px 7px 5px 0 rgba(50,50,50,.75);font-weight:700;font-size:10px;padding-left:5px;padding-top:2px}.image img[data-v-d9436604]{height:700px;width:650px}.column-blanco[data-v-d9436604]{padding-bottom:100px}@media (min-width:1025px) and (orientation:landscape){.column-plano[data-v-d9436604]{width:65%}.column-switch[data-v-d9436604]{width:30%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9436604","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checklist_Componentes/HomeChecklist.vue
// module id = 2878
// module chunks = 0